/**
 * Tab Component switching Tab content.
 * Each of tab content structure [{ label, content, priority, onClick, logo }, ...]
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _sortBy from 'lodash/sortBy';

import { TAB_CONTENT } from '../../../constants/PropTypesShapes';
import ColumnLayout from '../ColumnLayout';

class DialTabs extends Component {
  // Render customized Logo class as the background image
  static renderLogo(content) {
    return (
      <div className="channel-new-tab-logo">
        <div className={content.logo} />
      </div>
    );
  }

  constructor(props) {
    super(props);

    // Initial Tab state
    this.state = {
      currentIndex: this.props.defaultIndex,
      tabContents: _sortBy(this.props.options, (content) => content.priority), // Sort content based on content priority
    };
  }

  // Click handler for clicking one of the Tab options
  tabClickHandler(content, index) {
    this.setState({ currentIndex: index });
    if (typeof content.onClick === 'function') {
      content.onClick();
    }
  }

  // Render each of the tab option
  renderTabBtn() {
    return this.state.tabContents.map((content, index) => (
      <button
        className={`channel-new-tab-button ${this.state.currentIndex === index ? 'tab-active' : ''}`}
        onClick={() => this.tabClickHandler(content, index)}
      >
        {DialTabs.renderLogo(content)}
      </button>
    ));
  }

  // Render Tab switch buttons and Logo
  renderTabOptions() {
    return (
      <ColumnLayout
        customizeStyle="channel-new-tab-header"
        leftPanel={(
          <div className="channel-new-tab-buttons-region">
            {this.renderTabBtn()}
          </div>
        )}
      />
    );
  }

  // Base on current/selected index to render tab content body
  renderTabBody() {
    return (
      <div className="channel-new-tab-body">
        {this.state.tabContents[this.state.currentIndex].content}
      </div>
    );
  }

  render() {
    // TODO: update null checker, if there is only one tab content
    if (!Array.isArray(this.state.tabContents) || !this.state.tabContents.length) {
      return null;
    }

    return (
      <div className="channel-new-tab-container">
        {this.renderTabOptions()}
        {this.renderTabBody()}
      </div>
    );
  }
}

DialTabs.propTypes = {
  defaultIndex: PropTypes.number,
  options: PropTypes.arrayOf(PropTypes.shape(TAB_CONTENT)).isRequired,
};

DialTabs.defaultProps = {
  defaultIndex: 0,
};

export default DialTabs;
